
/* injects from baggage-loader */

'use strict';

import AccountSettingsSecurityComponent from './account.settings.security.component';

const AccountSettingsSecurityPageModule = angular.module('account-settings-security-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('account.settings.security', {
        data: {
          title: 'My Account Settings: Security',
          navTitle: 'Security'
        },
        url: '/security',
        component: 'accountSettingsSecurity',
        protected: true,
         // Resolve promises into controller bindings, see component for bindings
				resolve: {
					user: function (User) {
						return User.current();
					},
					currentSession: function (Session) {
						return Session.getCurrentSession();
					}
				}
      });
  })
  .component('accountSettingsSecurity', new AccountSettingsSecurityComponent());

export default AccountSettingsSecurityPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/account/settings/security/account.settings.security.module.js